import React, { useState } from "react";
import {
    Button, message
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getModuleCode } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import { removeToGridData, setWhitespacePieList } from "../../../../store/components/Reports.slice";
import WhiteSpaceCategoryPie from "./WhiteSpaceCategoryPie"
import WhiteSpaceCategoryLine from "./WhiteSpaceCategoryLine";
import WhiteSpaceColumnChart from "./WhiteSpaceColumnChart";
import WhiteSpacePieChartItem from "./WhiteSpacePieChartItem";
import WhiteSpaceBarChart from "./WhiteSpaceBarChart";
import { formatNumber } from "../../../../utils/MainHelper";

function WhiteSpaceChartCategoryItem({
    category,
    idx,
    showZeroInChart
}) {
    const dispatch = useDispatch();
    const moduleCode = getModuleCode();
    const { whitespacePieList } = useSelector((state) => state.reports);
    const clickBar = (topic, score, isFixedScore, topicData) => {
        const found = (whitespacePieList[category.path] || []).find((d) => (`${d.name} (${formatNumber(d.segmentSize)})`) === topic);
        if (found) {
            const newTopic = topic.split("(")[0];
            message.warning(`${newTopic} already displayed.`);
            return;
        }
        const foundItemData = topicData || category.children.find((d) => (`${d.name} (${formatNumber(d.segmentSize)})`) === topic);
        if (foundItemData) {
            dispatch(setWhitespacePieList({
                key: category.path,
                value: [...whitespacePieList[category.path] || [], foundItemData]
            }));
        }
    };

    const filteredZero = showZeroInChart ? category.children : category.children.filter((d) => d.diff > 0);
    const isMacro = (!category.name.includes(" > "));

    let height = "170mm";
    if (!isMacro) {
        if (category.name.includes(" > ")) {
            if (filteredZero.length <= 2) {
                height = "55%";
            } else if (filteredZero.length <= 5) {
                height = "75%";
            } else if (filteredZero.length >= 10) {
                height = `${100 + ((filteredZero.length / 2) * 10)}%`;
            }
        } else if (filteredZero.length >= 10) {
            height = `${100 + ((filteredZero.length / 2) * 10)}%`;
        }
    } else if (filteredZero.length > 15) {
        height = `${100 + ((filteredZero.length / 2) * 10)}%`;
    }
    const timePerChart = 1000 * (idx + 1);
    const chartTitle = (otherText, catname) => {
        const getTitle = (name, ext) => (
            <>
                <span>{name}</span>
                <span style={{
                    marginLeft: "2mm",
                    fontWeight: "normal"
                }}
                >
                    {otherText || (ext || "")}
                </span>
            </>
        );
        if (category.appended) {
            return getTitle(catname || category.name, "Deep Dive");
        }
        return getTitle(catname || category.name);
    };

    const deepDiveData = (() => {
        const isDeepdive = {};
        const tempList = (whitespacePieList[category.path] || []).reduce((acc, i) => {
            if (!i.isDeepdive) {
                acc.push(i);
            } else {
                const parentPath = i.namePath.replace(`/${i.name}`, "");
                if (!isDeepdive[parentPath]) isDeepdive[parentPath] = [];
                isDeepdive[parentPath].push(i);
            }
            return acc;
        }, []);

        return tempList.reduce((acc, d) => {
            acc.push(d);
            if (isDeepdive[d.namePath]) {
                acc.push({
                    name: d.namePath.replace("/", " > "),
                    isDeepdive: true,
                    children: isDeepdive[d.namePath]
                });
            }
            return acc;
        }, []);
    })();
    return (
        <>
            {isMacro && moduleCode === "brandloyalty" && <WhiteSpaceCategoryPie key={`${category.name}_overallpie`} category={category} />}
            {isMacro && moduleCode !== "brandloyalty" && <WhiteSpaceCategoryLine key={`${category.name}_overallline`} category={category} />}
            {/* {isMacro && <WhiteSpaceNewSummaryDisplay category={category} />} */}
            <div
                key={category.name}
                className="d-flex-col whitespace-chartItem whitespace-chartWithClose"
                name={category.name}
                style={{
                    width: "calc(100% - 2mm)",
                    height,
                    border: "1px solid #E2E8F0",
                    padding: "2mm",
                    marginBottom: "2mm",
                    borderRadius: "3px",
                    backgroundColor: (isMacro) ? "var(--bluegray-100)" : "white"
                }}
            >
                <Button
                    className="whitespace-chartWithClose-close"
                    type="link"
                    icon={<CloseOutlined className="whitespace-chartWithClose-icon" />}
                    danger
                    title="Remove"
                    onClick={() => {
                        dispatch(removeToGridData(category));
                    }}
                />
                <div style={{ padding: "4mm" }}>
                    <span className="fs-19 fw-700 c-bg-700">{chartTitle()}</span>
                </div>
                {
                    isMacro && filteredZero.length <= 10 ? (
                        <WhiteSpaceColumnChart
                            category={category.name}
                            visualData={filteredZero}
                            clickBar={clickBar}
                            timePerChart={timePerChart}
                            idx={idx + 1}
                        />
                    )
                        : (
                            <WhiteSpaceBarChart
                                category={category.name}
                                visualData={filteredZero}
                                clickBar={clickBar}
                                timePerChart={timePerChart}
                                idx={idx + 1}
                            />
                        )
                }
            </div>
            {deepDiveData.length ? (
                <div
                    key={`${category.name}_pie`}
                    className="d-flex-col whitespace-chartItem whitespace-chartWithClose"
                    name={`${category.name}_piecharts`}
                    style={{
                        width: "calc(100% - 2mm)",
                        height: "auto",
                        border: "1px solid #E2E8F0",
                        padding: "2mm",
                        marginBottom: "2mm",
                        borderRadius: "3px",
                        backgroundColor: "white"
                    }}
                >
                    <Button
                        className="whitespace-chartWithClose-close"
                        type="link"
                        icon={<CloseOutlined className="whitespace-chartWithClose-icon" />}
                        danger
                        title="Remove"
                        onClick={() => {
                            dispatch(setWhitespacePieList({
                                removeall: true
                            }));
                        }}
                    />
                    <span style={{ padding: "4mm" }} className="fs-19 fw-700 c-bg-700">
                        {chartTitle(isMacro ? "- Deep Dive" : "- Share of Consideration")}
                    </span>
                    <div
                        className="d-flex flex-wrap gap-1 align-items-start justify-content-center"
                    >
                        {deepDiveData.map((item) => {
                            if (item.isDeepdive && item.children) {
                                return (
                                    <div style={{ width: "100%", marginTop: "3mm" }} className="d-flex-col gap-2">
                                        <div style={{ position: "relative" }} className="whitespace-chartWithClose">
                                            <span style={{ padding: "4mm" }} className="fs-19 fw-700 c-bg-700">
                                                {chartTitle("- Share of Consideration", item.name)}
                                            </span>
                                            <Button
                                                className="whitespace-chartWithClose-close"
                                                type="link"
                                                icon={<CloseOutlined className="whitespace-chartWithClose-icon" />}
                                                danger
                                                title="Remove"
                                                onClick={() => {
                                                    const keys = item.children.map((k) => k.path);
                                                    dispatch(setWhitespacePieList({
                                                        key: category.path,
                                                        value: whitespacePieList[category.path].filter((d) => !keys.includes(d.path))
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <div className="d-flex flex-wrap gap-1 align-items-start justify-content-center">
                                            {item.children.map((sub) => (
                                                <WhiteSpacePieChartItem
                                                    key={`${sub.name}_pieItem`}
                                                    data={sub}
                                                    isMacro={false}
                                                    items={filteredZero}
                                                    showZeroInChart={showZeroInChart}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <WhiteSpacePieChartItem
                                    key={`${item.name}_pieItem`}
                                    data={item}
                                    isMacro={isMacro}
                                    items={filteredZero}
                                    showZeroInChart={showZeroInChart}
                                    clickBar={clickBar}
                                />
                            );
                        })}
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default WhiteSpaceChartCategoryItem;
